var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconSettings = function SvgIconSettings(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17.004,
    viewBox: "0 0 17 17.004",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1,13a2.188,2.188,0,0,1,1.4-2.041,8.671,8.671,0,0,0-1.049-2.528,2.217,2.217,0,0,1-.89.19,2.183,2.183,0,0,1-2-3.072A8.645,8.645,0,0,0,15.041,4.5a2.186,2.186,0,0,1-4.082,0A8.671,8.671,0,0,0,8.431,5.549a2.183,2.183,0,0,1-2,3.072,2.145,2.145,0,0,1-.89-.19A8.863,8.863,0,0,0,4.5,10.964a2.187,2.187,0,0,1,0,4.082,8.671,8.671,0,0,0,1.049,2.528,2.184,2.184,0,0,1,2.882,2.882A8.722,8.722,0,0,0,10.964,21.5a2.182,2.182,0,0,1,4.073,0,8.671,8.671,0,0,0,2.528-1.049,2.186,2.186,0,0,1,2.882-2.882A8.722,8.722,0,0,0,21.5,15.045,2.2,2.2,0,0,1,20.1,13ZM13.04,16.537A3.542,3.542,0,1,1,16.582,13,3.541,3.541,0,0,1,13.04,16.537Z",
    transform: "translate(-4.5 -4.5)",
    fill: "#f6c866"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSettings, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-settings.689b9bb5.svg";
export { ForwardRef as ReactComponent };